import { useSelector } from 'react-redux';
import AdminCalendar from "../../components/AdminCalendar";

function Schedule({}) {
    const jobs = useSelector((state) => state.shownData.myUpcomingJobs);
    console.log("jobs:", jobs);

    return (
        <div className="column g32 p32">
            <AdminCalendar jobs={jobs} />
        </div>
    );
}

export default Schedule;